import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export interface RecommendationSignature {
  // The arguments accepted by the component
  Args: {
    recommendation: any;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class Recommendation extends Component<RecommendationSignature> {
  @tracked showModal = false;

  @action
  toggleModal(val: boolean) {
    this.showModal = val;
  }

  @action
  openModal() {
    this.showModal = true;
  }

  get iconColor() {
    if (this.args.recommendation.type === 'action') {
      return 'text-red-700';
    }
    return 'text-amber-700';
  }

  get iconBgColor() {
    if (this.args.recommendation.type === 'action') {
      return 'bg-red-100';
    }
    return 'bg-amber-100';
  }
}
